import { LanguageCode } from '../../../localization/LanguageCode';

class DibsLanguageResolver {
  private static readonly defaultLanguage = 'en-GB';

  /** Keys are normalized language codes; values are the language identifiers Nets Easy accepts. */
  private static readonly languages = new Map([
    ['da-dk', 'da-DK'],
    ['de-at', 'de-DE'],
    ['de-ch', 'de-DE'],
    ['de-de', 'de-DE'],
    ['en-gb', 'en-GB'],
    ['en-us', 'en-GB'],
    ['fr-be', 'fr-FR'],
    ['fr-ch', 'fr-FR'],
    ['fr-fr', 'fr-FR'],
    ['nb-no', 'nb-NO'],
    ['nl-be', 'nl-NL'],
    ['nl-nl', 'nl-NL'],
    ['pl-pl', 'pl-PL'],
    ['sv-se', 'sv-SE'],
  ]);

  public static resolve(languageCode: string) {
    return this.languages.get(LanguageCode.normalize(languageCode)) ?? this.defaultLanguage;
  }
}

export default DibsLanguageResolver;
